<section class="box-border flex flex-col px-4 lg:px-6 xl:px-8 py-0 my-0 w-full" *ngIf="products.length > 0">
  <header class="flex flex-wrap gap-10 mb-3 sm:mb-4 mt-2 justify-between items-center w-full max-w-full">
    <h2
      class="text-2xl font-bold text-black leading-8 max-md:text-lg max-md:leading-7 max-sm:text-base max-sm:leading-6">
      Recently Viewed Parts
    </h2>
    <!-- <a *ngIf="products.length > 9" class="flex text-base font-bold text-blue-500 text-center leading-6 max-md:text-sm max-md:leading-5 max-sm:text-xs max-sm:leading-4 max-sm:mt-2 cursor-pointer"
      (click)="gotoProductList()">
      View all
    </a> -->
  </header>

  <div class="relative mb-3 sm:mb-6 md:mb-10 w-full">
    <!-- Carousel container -->

    <div class="overflow-hidden max-sm:overflow-x-auto max-sm:-mx-2 custom-scrollbar-hide">
      <div class="flex gap-5 max-md:gap-2.5 max-sm:gap-2 transition-transform duration-300 ease-in-out px-0" [ngStyle]="{
          transform:
            'translateX(-' +
            (currentSlide > products.length - visibleSlides
              ? products.length - visibleSlides - 1
              : currentSlide - 1) *
              slideWidth +
            'px)',
        }">
        <!-- Product card -->
        <article *ngFor="let product of products"
          class="seller-card flex flex-col bg-white rounded-lg shadow-sm flex-shrink-0 w-[calc(50%-6px)] min-w-[calc(50%-6px)] max-w-[calc(50%-6px)] sm:w-[240px] sm:min-w-[240px] sm:max-w-[240px] md:w-[220px] md:min-w-[220px] md:max-w-[220px] lg:w-[260px] lg:min-w-[260px] lg:max-w-[260px] xl:w-[300px] xl:min-w-[300px] xl:max-w-[300px]">
          <figure class="overflow-hidden self-stretch bg-white rounded-t-lg w-full">
            <div class="relative group w-full h-[220px] max-md:h-[135px] max-sm:h-[135px] cursor-pointer"
              (mouseenter)="onProductHover(product)" (mouseleave)="onProductHoverEnd()">
              <!-- Grade Badge -->
              <div *ngIf="product?.quality_s" [ngClass]="
                  product?.quality_s === 'A'
                    ? 'bg-green-100 text-green-800'
                    : product?.quality_s === 'B'
                      ? 'bg-yellow-100 text-yellow-800'
                      : product?.quality_s === 'C'
                        ? 'bg-orange-100 text-orange-800'
                        : 'bg-green-100 text-green-800'
                " class="absolute top-2 left-2 z-10 flex items-center px-2 py-1 rounded shadow font-bold text-xs">
                <svg width="20" height="20" class="mr-1">
                  <rect width="20" height="20" rx="4" [attr.fill]="
                      product?.quality_s === 'A'
                        ? '#01811D'
                        : product?.quality_s === 'B'
                          ? '#B8860B'
                          : product?.quality_s === 'C'
                            ? '#D35400'
                            : '#01811D'
                    " />
                  <text x="10" y="15" text-anchor="middle" font-size="12" font-family="Arial, sans-serif" fill="white">
                    {{ product.quality_s }}
                  </text>
                </svg>
                Quality
              </div>

              <!-- Left Arrow -->
              <button *ngIf="
                  hoveredProduct === product &&
                  product?.part_image_path?.length > 1
                " (click)="prevImage(product)"
                class="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
                <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
                  <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <!-- Product Image -->
              <img [src]="getCurrentImage(product)" [alt]="product | productName"
                class="object-cover bg-zinc-100 rounded-t-lg w-full h-full" />

              <!-- Right Arrow -->
              <button *ngIf="
                  hoveredProduct === product &&
                  product?.part_image_path?.length > 1
                " (click)="nextImage(product)"
                class="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow group-hover:flex hidden">
                <svg width="24" height="24" fill="none" stroke="black" stroke-width="2">
                  <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

              <!-- Carousel Dots -->
              <div *ngIf="
                  hoveredProduct === product &&
                  product?.part_image_path?.length > 1
                " class="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 z-10 group-hover:flex hidden">
                <span *ngFor="let img of product?.part_image_path; let i = index" class="w-3 h-1.5 rounded-full"
                  [ngClass]="{
                    'bg-gray-400': i !== product.currentImageIndex,
                    'bg-white border border-gray-400':
                      i === product.currentImageIndex,
                  }"></span>
              </div>
            </div>
          </figure>

          <!-- Wrapper with content spacing -->
          <div class="flex flex-col flex-1 p-3 max-md:p-2 w-full text-base">
            <!-- Product Name (allow wrapping for readability) -->
            <h3 class="font-bold text-base max-md:text-xs leading-tight line-clamp-2 cursor-pointer"
              (click)="gotoProductDetails(product)">
              {{ product | productName }}
            </h3>

            <!-- Product Description (2 lines fixed height) -->

            @if (product.part_type === "Used Part") {
            <div
              class="flex flex-wrap gap-1 mt-1.5 text-[var(--Text-Header,#464646)] text-xs max-md:text-[10px] leading-relaxed line-clamp-2 cursor-pointer"
              (click)="gotoProductDetails(product)">
              <span *ngIf="product?.make">{{ product.make }}</span>
              <span *ngIf="product?.make">•</span>
              <span *ngIf="product?.model">{{
                product.model | slice: 0 : 10
                }}</span>
              <span *ngIf="product?.model">•</span>
              <span *ngIf="product?.year_of_manufacture">{{
                product.year_of_manufacture
                }}</span>
              <span *ngIf="product?.year_of_manufacture">•</span>
              <span *ngIf="product?.variant">{{
                product.variant | slice: 0 : 10
                }}</span>
            </div>

            <!-- Price -->
            <div class="flex flex-wrap gap-2 items-baseline cursor-pointer" (click)="gotoProductDetails(product)">
              <span class="text-black text-[16px] max-md:text-[13px] font-bold leading-[24px]">
                ₹{{
                product.discounted_price
                ? product.discounted_price
                : product.price_s
                ? product.price_s
                : 0
                }}
              </span>

              <span class="text-sm max-md:text-[11px] font-medium line-through text-gray-500" *ngIf="
                    product.discount_percentage &&
                    product?.price_s &&
                    product?.discount_percentage > 0
                  ">
                ₹{{ product.price_s.toLocaleString() }}
              </span>

              <span
                class="px-2 py-1 text-xs font-bold text-white bg-emerald-800 rounded-xl whitespace-nowrap max-md:text-[9px]"
                *ngIf="
                    product.discounted_price && product.discount_percentage > 0
                  ">
                {{ product?.discount_percentage }}% Off
              </span>
            </div>

            <!-- Delivery Info -->
            <div
              class="flex flex-wrap gap-2 max-md:gap-1 justify-between items-center max-md:mt-2 w-full text-xs max-md:text-[10px] text-black cursor-pointer"
              (click)="gotoProductDetails(product)">
              <div class="flex gap-2 items-center">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/159106a761a7f15320c0f68daf98475a8b885037?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  class="object-contain w-5 h-5 max-md:w-4 max-md:h-4 shrink-0" alt="Delivery icon" />
                <div class="flex gap-1">
                  <span
                    class="font-medium max-sm:text-[var(--Text-Black,#000)] max-sm:text-[12px] max-sm:font-medium max-sm:leading-[16px]"
                    *ngIf="!isMobile">Delivery by</span>
                  <span class="font-bold">{{
                    product?.updated_at_dt | date: "mediumDate"
                    }}</span>
                </div>
              </div>

              <div class="flex gap-2 items-center font-medium">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/2fc8fd76d79d6a90707392d795823ac38c4dc37c?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
                  class="object-contain w-5 h-5 max-md:w-4 max-md:h-4 shrink-0" alt="Store pickup" />
                <span>Store pickup</span>
              </div>
            </div>
            } @else {
            <div class="flex flex-col gap-1.5 max-sm:gap-1 text-sm cursor-pointer">
              <p class="text-gray-600 text-sm max-md:text-[11px] break-words">
                Seller:
                <span class="text-[#0A0A5F] font-bold">{{
                  product?.seller_name
                  }}</span>
              </p>
              <div class="flex flex-wrap items-center gap-2 max-md:gap-1">
                <p class="text-black text-sm max-md:text-[12px] font-bold">
                  ₹{{
                  product?.discounted_taxable
                  ? product?.discounted_taxable
                  : product?.taxable_amount
                  }}/<ng-container
                    *ngIf="isOilProductWithLiter(product); else showKgPrice">Ltr</ng-container><ng-template
                    #showKgPrice>Kg</ng-template>
                </p>
                <p class="text-[#777] line-through text-[12px] max-md:text-[10px] font-medium leading-[16px] max-sm:block"
                  *ngIf="product?.discount_percentage > 0">
                  ₹{{ product?.taxable_amount }}
                </p>
                <span
                  class="flex items-center justify-center gap-1 p-[6px] rounded-[10px] bg-[#006C3B] text-white text-[10px] max-md:text-[9px] font-bold leading-[12.487px] whitespace-nowrap"
                  *ngIf="
                      product?.discount_percentage &&
                      product?.discount_percentage > 0
                    ">
                  {{ product?.discount_percentage }}% off
                </span>
              </div>

              <div
                class="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs max-md:text-[10px] text-gray-500 mt-1 max-sm:mt-0.5 break-words">
                <p>
                  Min Booking Qty:
                  <span class="text-black text-sm max-md:text-[11px] font-bold">
                    <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                      product?.min_quantity || product?.min_qty || 0
                      }}
                      kg</ng-container>
                    <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                      (product?.min_quantity || product?.min_qty || 0) / 1000
                      }}
                      ton</ng-container>
                    <ng-container *ngIf="
                          product.selectedUnit === 'liter' ||
                          isOilProductWithLiter(product)
                        ">{{
                      product?.min_quantity || product?.min_qty || 0
                      }}
                      ltr</ng-container>
                  </span>
                </p>
                <p>
                  Max Booking Qty:
                  <span class="text-black text-sm max-md:text-[11px] font-bold">
                    <ng-container *ngIf="product.selectedUnit === 'kg'">{{
                      product.max_booking_qty ||
                      product.max_booking_quantity ||
                      product.max_quantity ||
                      product.available_quantity ||
                      product.fix_quantity ||
                      0
                      }}
                      kg</ng-container>
                    <ng-container *ngIf="!product.selectedUnit || product.selectedUnit === 'ton'">{{
                      (product.max_booking_qty ||
                      product.max_booking_quantity ||
                      product.max_quantity ||
                      product.available_quantity ||
                      product.fix_quantity ||
                      0) / 1000
                      }}
                      ton</ng-container>
                    <ng-container *ngIf="
                          product.selectedUnit === 'liter' ||
                          isOilProductWithLiter(product)
                        ">{{
                      product.max_booking_qty ||
                      product.max_booking_quantity ||
                      product.max_quantity ||
                      product.available_quantity ||
                      product.fix_quantity ||
                      0
                      }}
                      ltr</ng-container>
                  </span>
                </p>
              </div>

              <div class="product-card-qty-box mt-1.5 max-sm:mt-1">
                <!-- Quantity input/select based on unit -->
                <div *ngIf="
                      !product.selectedUnit || product.selectedUnit === 'ton'
                    " class="flex flex-1 min-w-0">
                  <!-- Show select dropdown when not in custom mode -->
                  <select *ngIf="product.quantity !== 'custom'" (change)="onTonQuantitySelect(product, $event)"
                    [value]="product.quantity || ''"
                    class="qty-dropdown">
                    <option value="" [selected]="!product.quantity">
                      Select any one
                    </option>
                    <option value="10" *ngIf="!isOilProductWithLiter(product)">
                      10
                    </option>
                    <option value="15" *ngIf="!isOilProductWithLiter(product)">
                      15
                    </option>
                    <option value="20" *ngIf="!isOilProductWithLiter(product)">
                      20
                    </option>
                    <option value="25" *ngIf="!isOilProductWithLiter(product)">
                      25
                    </option>
                    <option value="50" *ngIf="!isOilProductWithLiter(product)">
                      50
                    </option>
                    <option value="custom" *ngIf="!isOilProductWithLiter(product)">
                      Custom
                    </option>
                  </select>
                  <!-- Show input field when custom is selected -->
                  <input *ngIf="product.quantity === 'custom'" type="number" placeholder="Enter quantity"
                    [value]="product.customTonQuantity || ''" (input)="onCustomTonQuantityInput(product, $event)"
                    (blur)="onCustomTonQuantityBlur(product, $event)" [id]="'customInput-' + product.part_number"
                    class="qty-input"
                    min="1" step="0.1" />
                </div>

                <div *ngIf="product.selectedUnit === 'kg'" class="flex flex-1 min-w-0">
                  <input type="number" placeholder="Enter quantity" [value]="product.customKgQuantity || ''"
                    (input)="onKgQuantityChange(product, $event)"
                    class="qty-input"
                    min="1" step="1" />
                </div>
                <div *ngIf="
                      product.selectedUnit === 'liter' ||
                      isOilProductWithLiter(product)
                    " class="flex flex-1 min-w-0">
                  <input type="number" placeholder="Enter quantity" [value]="product.customLiterQuantity || ''"
                    (input)="onLiterQuantityChange(product, $event)"
                    class="qty-input"
                    min="1" step="1" />
                </div>

                <div class="unit-divider"></div>

                <!-- Unit select -->
                <select (change)="onUnitChange(product, $event)" [value]="product.selectedUnit || 'ton'"
                  class="unit-dropdown">
                  <option value="ton" *ngIf="!isOilProductWithLiter(product)">
                    ton
                  </option>
                  <option value="kg" *ngIf="!isOilProductWithLiter(product)">
                    kg
                  </option>
                  <option value="liter" *ngIf="isOilProductWithLiter(product)">
                    ltr
                  </option>
                </select>
              </div>

              <!-- Error message for quantity validation -->
              <span *ngIf="
                    product.quantityTouched &&
                    (getSelectedQuantity(product) === 0 ||
                      getSelectedQuantity(product) === null ||
                      getSelectedQuantity(product) === undefined)
                  " class="mt-2 text-[10px] sm:text-xs text-red-600">
                Please select a quantity
              </span>
              <span *ngIf="
                    product.quantityTouched &&
                    getSelectedQuantity(product) > 0 &&
                    getSelectedQuantity(product) <
                      (product.min_quantity || product.min_qty || 0)
                  " class="mt-2 text-[10px] sm:text-xs text-red-600">
                Minimum quantity is
                <ng-container *ngIf="
                      product.selectedUnit === 'kg' ||
                      (!product.selectedUnit && !isOilProductWithLiter(product))
                    ">{{
                  product.min_quantity || product.min_qty || 0
                  }}
                  kg</ng-container><ng-container *ngIf="product.selectedUnit === 'ton'">{{
                  (product.min_quantity || product.min_qty || 0) / 1000
                  }}
                  ton</ng-container><ng-container *ngIf="
                      product.selectedUnit === 'liter' ||
                      isOilProductWithLiter(product)
                    ">{{
                  product.min_quantity || product.min_qty || 0
                  }}
                  ltr</ng-container>
              </span>
              <span *ngIf="
                    product.quantityTouched &&
                    getSelectedQuantity(product) > 0 &&
                    getSelectedQuantity(product) >
                      (product.max_booking_qty ||
                        product.max_booking_quantity ||
                        product.max_quantity ||
                        product.available_quantity ||
                        product.fix_quantity ||
                        0)
                  " class="mt-2 text-[10px] sm:text-xs text-red-600">
                Maximum available quantity is
                <ng-container *ngIf="
                      product.selectedUnit === 'kg' ||
                      (!product.selectedUnit && !isOilProductWithLiter(product))
                    ">{{
                  product.max_booking_qty ||
                  product.max_booking_quantity ||
                  product.max_quantity ||
                  product.available_quantity ||
                  product.fix_quantity ||
                  0
                  }} kg</ng-container>
                <ng-container *ngIf="product.selectedUnit === 'ton'">{{
                  (product.max_booking_qty ||
                  product.max_booking_quantity ||
                  product.max_quantity ||
                  product.available_quantity ||
                  product.fix_quantity ||
                  0) / 1000
                  }} ton</ng-container>
                <ng-container *ngIf="
                      product.selectedUnit === 'liter' ||
                      isOilProductWithLiter(product)
                    ">{{
                  product.max_booking_qty ||
                  product.max_booking_quantity ||
                  product.max_quantity ||
                  product.available_quantity ||
                  product.fix_quantity ||
                  0
                  }} ltr</ng-container>
              </span>
            </div>
            }
            <div *ngIf="product?.is_locked"
              class="flex items-center gap-2 text-[#E30613] text-[12px] font-bold max-md:text-base">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16">
                <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
                <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
                <circle cx="16" cy="23" r="2" fill="red" />
              </svg>
              <span>This part is no longer available for purchase.</span>
            </div>
            <!-- CTA Buttons -->
            <div class="flex flex-row gap-1.5 mt-auto pt-3 max-md:pt-1.5 w-full font-bold text-center">
              <app-buy-now-button [productData]="product" [isLocked]="product?.is_locked"
                (buyNowClicked)="onBuyNow(product)" (paymentSuccess)="onPaymentSuccess($event)"
                class="flex-1 min-w-0">
              </app-buy-now-button>

              <!-- Animated Cart Button -->
              <button [disabled]="product?.is_locked"
                class="cart-btn flex items-center justify-center gap-0.5 px-1 py-1.5 max-md:py-1 text-[10px] md:text-[11px] xl:text-sm flex-1 min-w-0 min-h-8 max-md:min-h-8 xl:min-h-10 bg-blue-500 rounded-lg"
                [class.added]="itemsAddedToCart.has(product?.inventory_id)" [class.disabled]="product?.is_locked"
                (click)="
                  itemsAddedToCart.has(product?.inventory_id)
                    ? goToCart()
                    : onAddToCartClicked($event, product)
                ">
                <div class="cart-content cart-content-add">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"
                    class="cart-icon-svg max-md:w-3.5 max-md:h-3.5">
                    <rect width="20" height="20" transform="translate(0.5)" fill="none" />
                    <path
                      d="M8.8335 16.6664C9.52373 16.6664 10.0833 17.2262 10.0835 17.9164C10.0835 18.6067 9.52383 19.1664 8.8335 19.1664C8.14314 19.1664 7.5835 18.6067 7.5835 17.9164C7.58367 17.2262 8.14325 16.6664 8.8335 16.6664ZM14.6665 16.6664C15.3568 16.6664 15.9163 17.2262 15.9165 17.9164C15.9165 18.6067 15.3569 19.1664 14.6665 19.1664C13.9763 19.1662 13.4165 18.6066 13.4165 17.9164C13.4167 17.2263 13.9764 16.6665 14.6665 16.6664ZM3.27002 1.04138C4.39468 1.04138 5.36515 1.84432 5.55322 2.95447L5.79346 4.37439H17.9878C18.9333 4.37452 19.6497 5.25689 19.4136 6.18884L18.3052 10.558C18.0453 11.5821 17.116 12.2913 16.0601 12.2914H7.82471C7.57773 12.2914 7.33826 12.2503 7.11279 12.1781L7.3374 13.5062C7.4341 14.0783 7.78213 14.3741 8.22314 14.3744H16.3335L16.4595 14.3871C16.7439 14.4454 16.9582 14.6977 16.9585 14.9994C16.9585 15.3013 16.7441 15.5533 16.4595 15.6117L16.3335 15.6244H8.22314C7.03842 15.624 6.27937 14.7463 6.10498 13.7152L5.54053 10.3783L4.64893 5.10388L4.3208 3.16345C4.23669 2.66692 3.79757 2.29138 3.27002 2.29138H2.1665C1.82146 2.29123 1.5415 2.01146 1.5415 1.66638C1.54168 1.32145 1.82156 1.04154 2.1665 1.04138H3.27002ZM6.77295 10.1693C6.8569 10.6659 7.29715 11.0412 7.82471 11.0414H16.0601C16.5551 11.0413 16.9778 10.7098 17.0942 10.2504L18.2017 5.88123C18.2316 5.76161 18.1414 5.62452 17.9878 5.62439H6.00439L6.77295 10.1693Z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-[10px] md:text-[11px] xl:text-sm font-bold text-white">Add to Cart</span>
                </div>
                <div class="cart-content cart-content-go">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    class="cart-icon-svg w-5 h-5 max-md:w-3.5 max-md:h-3.5">
                    <path
                      d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                      fill="white" />
                  </svg>
                  <span class="btn-text text-[10px] md:text-[11px] xl:text-sm font-bold text-white">Go to Cart</span>
                </div>
              </button>
            </div>
          </div>
        </article>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <!-- Navigation Buttons -->
    <div class="flex justify-between items-center w-full max-sm:hidden">
      <button *ngIf="products.length > visibleSlides"
        class="absolute left-0 top-[45%] -translate-y-1/2 z-10 flex justify-center items-center w-10 h-10 text-white bg-blue-500 rounded-lg shadow-md transition hover:-translate-x-1 disabled:bg-gray-300 disabled:cursor-not-allowed"
        [disabled]="currentSlide === 0" (click)="prev()" aria-label="Previous slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18l-5.293-5.293a1 1 0 010-1.414L15 6" stroke="white" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>

      <button *ngIf="products.length > visibleSlides"
        class="absolute right-0 top-[45%] -translate-y-1/2 z-10 flex justify-center items-center w-10 h-10 text-white bg-blue-500 rounded-lg shadow-md transition hover:translate-x-1 disabled:bg-gray-300 disabled:cursor-not-allowed"
        [disabled]="currentSlide >= products.length - visibleSlides" (click)="next()" aria-label="Next slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 6l5.293 5.293a1 1 0 010 1.414L9 18" stroke="white" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</section>

<!-- Buy Now Popup -->
<app-buy-now-popup [productData]="selectedProductForBuyNow" [isOpen]="isBuyNowPopupOpen"
  [quantity]="getQuantityForPopup(selectedProductForBuyNow)" [unit]="
    selectedProductForBuyNow?.selectedUnit === 'kg'
      ? 'Kg'
      : selectedProductForBuyNow?.selectedUnit === 'liter'
        ? 'Liter'
        : 'Ton'
  " (close)="closeBuyNowPopup()" (paymentSuccess)="onPaymentSuccess($event)">
</app-buy-now-popup>

<!-- Scrap Certificate Modal -->
<app-scrap-certificate-modal></app-scrap-certificate-modal>